<template>
	<div id="indexpage" v-title :data-title="title" style="height:100%;" class="ddjjfz">
		<!-- <headerbar msg="chanyednao" :curindex="false"> </headerbar> -->

		<leftnav mkcode="D" itemcode="D-ZHFZ" :smScrennFull="true"></leftnav>
		<!-- 弹框 -->


		<div class="por" style="background-color: #041034;height:100%;">
			<div class="index-swiper centerpage">
				<!-- <h2 class="title dataswipertitle"  @mouseover="drawer = true">
					<span v-if="userdata.countyText ==''">{{userdata.cityText}}</span>
					<span v-if="userdata.countyText !=''">{{userdata.countyText}}</span>{{title}}<i class="el-icon-arrow-down dataswipertitle_icon"></i>
					</h2> -->
				<daswiperNav :title="title" navcode="DDJJFZ"  :indexnum="2" :fulltitle="true"></daswiperNav>
				<div class="indexflex qxzhswiper">
					<div class="col3  qxzh_left">
						<div class="transparentbg hcol6">
							<h3 class="swiper_title">规模以上工业企业</h3>
							<div id="ddjjfz_chart1">
							</div>
						</div>
						<div class=" transparentbg hcol4">
							<h3 class="swiper_title">财政收支</h3>
							<div id="ddjjfz_chart2"></div>
						</div>
					</div>
					<div class="col4">
						<div class="">
							<div class="transparentbg ddjjfz_gdp">
								<h3 class="swiper_title">地区生产总值</h3>
								<div id="ddjjfz_chart3"></div>
							</div>
						</div>
						<div class="transparentbg hcol4">
							<h3 class="swiper_title">产业增加值</h3>
							<div id="ddjjfz_chart4"></div>
						</div>
					</div>
					<div class="col3  qxzh_right">
						<div class="ddjjfz_right_top transparentbg">
							<h3 class="swiper_title">农业发展情况</h3>
							<div class="ddjjfz_nybox flexcss">
								<div class="ny_list1 ny_list" v-for="item in pagedata.agrDevelop">
									<h3>{{ item.name }}</h3>
									<p class="">{{ item.value }}<span class="ddjj_comfont">{{ item.unit }}</span></p>
								</div>
							</div>
						</div>
						<div class="ddjjfz_right_center transparentbg">
							<h3 class="swiper_title">民生发展情况</h3>
							<ul class="ddjjfz-topind pdrl15 flexcss">
								<li>
									<h5 class="fl title">{{ pagedata.msfz[0].name }} : </h5>
									<span
										class="yellfont">{{ pagedata.msfz[0].value }}<em>{{ pagedata.msfz[0].unit }}</em></span>
								</li>
								<li>
									<h5 class="fl title">{{ pagedata.msfz[1].name }} : </h5>
									<span
										class="yellfont">{{ pagedata.msfz[1].value }}<em>{{ pagedata.msfz[1].unit }}</em></span>
								</li>
								<li>
									<h5 class="fl title">{{ pagedata.msfz[2].name }} : </h5>
									<span
										class="yellfont">{{ pagedata.msfz[2].value }}<em>{{ pagedata.msfz[2].unit }}</em></span>
								</li>
								<li>
									<h5 class="fl title">{{ pagedata.msfz[3].name }} : </h5>
									<span
										class="yellfont">{{ pagedata.msfz[3].value }}<em>{{ pagedata.msfz[3].unit }}</em></span>
								</li>
								<li>
									<h5 class="fl title">提供住宿的社会工作机构 : </h5>
									<span
										class="yellfont">{{ pagedata.msfz[4].value }}<em>{{ pagedata.msfz[4].unit }}</em></span>
								</li>
								<li>
									<h5 class="fl title">提供住宿的社会工作机构床位 : </h5>
									<span
										class="yellfont">{{ pagedata.msfz[5].value }}<em>{{ pagedata.msfz[5].unit }}</em></span>
								</li>
							</ul>
						</div>
						<div class="qxzh_right_bottom transparentbg">
							<h3 class="swiper_title">存贷款情况</h3>
							<div id="ddjjfz_chart5"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div></template>
<script>
import mappng from '../../assets/images/mapbg.png';
export default {
	name: 'quxianzonghe',
	data() {
		return {
			isCollapse: false,
			isFullscreen: false,
			direction: "ltr",  //btt
			direction2: "btt",  //btt
			drawer: false,
			drawer2: false,
			modal: false,
			title: "当地经济发展大屏",
			bgcolor: "#041034",
			usernotionlistsave: [],
			userdata: {},
			clynav: 1,
			clychartnav: 1,
			mapurl: 'map/city/321200.json',
			contodefault: {
				duration: 1000,
				autoplay: true,
			},
			islogin: false,
			flag: true,
			swipernum: 3,
			zoom: 13,
			public_tooltip: {
				trigger: 'axis',
				backgroundColor: 'rgba(255,255,255,0.9)',
				borderColor: '#ddd',
				borderWidth: '1',
				textStyle: {
					color: '#000',
					fontSize: 14,
				}
			},
			mapurl: 'map/city/321200.json',
			colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
			landType: [],
			startCharts: null,
			pagedata: {
				"msfz": [
					{
						"name": "固定电话用户",
						"year": 2019,
						"value": 40800,
						"unit": "户"
					},
					{
						"name": "普通中学在校生数",
						"year": 2019,
						"value": 30257,
						"unit": "人"
					},
					{
						"name": "普通小学在校学生数",
						"year": 2019,
						"value": 20185,
						"unit": "人"
					},
					{
						"name": "医疗卫生机构床位数",
						"year": 2019,
						"value": 2520,
						"unit": "张"
					},
					{
						"name": "各种社会福利收养性单位数",
						"year": 2019,
						"value": 9,
						"unit": "个"
					},
					{
						"name": "各种社会福利收养件单位床位数",
						"year": 2019,
						"value": 875,
						"unit": "床"
					}
				]
			},
			//假数据  
			retail: [
				{ name: "2016", value: 1432 },
				{ name: "2017", value: 1253 },
				{ name: "2018", value: 1104 },
				{ name: "2019", value: 991 },
				{ name: "2020", value: 593 },
			],
			gdpdata: [
				{ name: "1", value: 932 },
				{ name: "2", value: 853 },
				{ name: "3", value: 991 },
				{ name: "4", value: 1104 },
				{ name: "5", value: 593 },
				{ name: "7", value: 523 },
				{ name: "8", value: 623 },
			],
		}
	},
	props: {
		msg: String,
	},
	computed: {
		defaultOption() {
			return {
				step: 0.7, // 数值越大速度滚动越快
				limitMoveNum: this.enterpriselist.length, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 1, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			}
		},
		defaultOption2() {
			return {
				step: 0.7, // 数值越大速度滚动越快
				limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 1, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			}
		}
	},
	mounted() {
		document.getElementById('app').style.background = this.bgcolor;
		this.userdata = this.getuseriformation();
		// console.log(this.userdata);
		this.bus.$emit('loading', true);
		if (this.userdata.edition < 1) {
			alert('升级版本后即可查看本页面,自动跳转');
			setTimeout(function () {
				_this.routerself('/totalEnterprises');
			}, 1000)
			return;
		}
		this.getajasdata();
	},
	methods: {
		getajasdata(type) {
			var _this = this;
			// this.bus.$emit('loading', true);
			var ajaxurl = this.$api.cyl.govsaaschart.qxEcoDevelop();
			console.log(this.title);
			this.$axios.get(ajaxurl, {
				headers: { AuthToken: this.userdata.token }
			}).then(function (res) {
				console.log(res);
				if (res.data.success) {
					_this.TaxchartFun('ddjjfz_chart1', res.data.data.gy0101);
					_this.imexportFun('ddjjfz_chart2', res.data.data.cz0101, res.data.data.cz0201);
					_this.GDPFun('ddjjfz_chart3', res.data.data.gdp);
					_this.accessFun('ddjjfz_chart5', res.data.data.jr0102, res.data.data.jr010102);
					_this.pagedata = res.data.data;
					_this.pagedata.msfz = res.data.data.msfz;
					_this.cyaddFun('ddjjfz_chart4', res.data.data.jj0801, res.data.data.jj0802, res.data.data.jj0803); //产业增加值
					_this.bus.$emit('loading', false);
				}
			}).catch(function (error) {
				_this.bus.$emit('loading', false);
				// 请求失败处理 console.log(error);
			});
		},

		//规模以上工业企业
		TaxchartFun(el, data) {
			var charPie3currentIndex = 0, isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var Taxchart = echarts.init(document.getElementById(el));
			var xdata = [], ydata = [];
			// console.log('社会人均收入支出',el,srdata,zcdata);
			for (var i = 0; i < data.length; i++) {
				xdata.push(data[i].name);
				ydata.push(data[i].value);
			}
			var option = {
				title: {
					text: '',
				},
				tooltip: {
					show: true,
					trigger: 'axis'
				},
				legend: {
					show: true,
					textStyle: { color: "#eee", fontSize: 12, },
					icon: 'rect',  //图例样式 圆点circle 矩形rect
					itemWidth: 10,
					itemHeight: 9,
					right: '5%',
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				xAxis: [
					{
						type: 'category',
						boundaryGap: false,
						color: "#eee",
						data: xdata,
						axisLine: { show: true, lineStyle: { color: '#eee', } }, 		//轴线
						axisTick: { show: false }, //刻度线
						axisLabel: {
							formatter: function (value, index) { return value + '年'; },  // x轴加单位
						},
					}
				],
				yAxis: [
					{
						type: 'value',
						min: 0,				//最小值
						// max: 400,			//最大值
						// interval: 100,		//步长值
						splitLine: { show: false }, //不显示网格线
						axisLine: { show: false, lineStyle: { color: '#eee', } }, 		//轴线
					}
				],
				series: [
					{
						name: '规模以上工业企业（个）',
						data: ydata,
						type: 'line',
						smooth: true, //线条平滑

						symbol: 'circle', //拐点样式
						symbolSize: 5,//拐点大小
						color: '#1890ff',
						areaStyle: { color: 'rgba(0,176,255,.5)' },
						// stack: 'Total', //同个类目轴上系列配置相同的stack值后，后一个系列的值会在前一个系列的值上相加
					},
				]
			};
			Taxchart.setOption(option);
			var startCharts = null;
			// 2、鼠标移动上去的时候的高亮动画
			Taxchart.on('mouseover', function (param) {
				isSet = false
				clearInterval(startCharts)
				// 取消之前高亮的图形
				Taxchart.dispatchAction({
					type: 'downplay',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				// 高亮当前图形
				Taxchart.dispatchAction({
					type: 'highlight',
					seriesIndex: 0,
					dataIndex: param.dataIndex
				})
				// 显示 tooltip
				Taxchart.dispatchAction({
					type: 'showTip',
					seriesIndex: 0,
					dataIndex: param.dataIndex
				})
			});
			var chartHover = function () {
				var dataLen = option.series[0].data.length
				// 取消之前高亮的图形
				Taxchart.dispatchAction({
					type: 'downplay',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
				// 高亮当前图形
				Taxchart.dispatchAction({
					type: 'highlight',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				// 显示 tooltip
				Taxchart.dispatchAction({
					type: 'showTip',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
			}
			startCharts = setInterval(chartHover, 2000)
			// 4、鼠标移出之后，恢复自动高亮
			Taxchart.on('mouseout', function (param) {
				if (!isSet) {
					startCharts = setInterval(chartHover, 2000)
					isSet = true
				}
			});
		},

		//财政收支
		imexportFun(el, data1, data2) {
			var charPie3currentIndex = 0, isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var imexport = echarts.init(document.getElementById(el));
			var _this = this, xline = [], expdata = [], impdata = [];
			for (var i = 0; i < data1.length; i++) {
				xline.push(data1[i].name);
				expdata.push(data1[i].value);
			}
			for (var x = 0; x < data2.length; x++) {
				impdata.push(data2[x].value);
			}
			var option = {
				tooltip: {
					trigger: 'axis',
				},
				legend: {
					show: true,
					textStyle: { color: "#eee", fontSize: 12, itemWidth: 10, itemHeight: 10, },
					icon: 'rect',  //图例样式 圆点circle 矩形rect
					itemWidth: 10,
					itemHeight: 10,
					right: '3%',
				},
				grid: { x: 80, y: 10, x2: 40, y2: 40 },
				xAxis: [
					{
						type: 'category',
						data: xline,
						axisPointer: {
							type: 'shadow'
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#eee',
							},
						},
						axisTick: { "show": true },
						axisLabel: {
							formatter: function (value, index) { return value + '年'; },  // x轴加单位
						},
					}
				],
				yAxis: [
					{
						type: 'value',
						name: ' ',
						axisTick: { "show": true },
						axisLine: {
							show: false,
							lineStyle: {
								color: '#eee',
							}
						},
						splitLine: { show: false }, //不显示背景分割线

					},
				],
				series: [
					{
						name: '一般公共预算收入（亿元）',
						type: 'bar',
						barWidth: 25,
						color: '#1890ff',
						itemStyle: {
							normal: {
								barBorderRadius: 8,   //柱形圆角
							}
						},
						barGap: '70%',						//柱子之间的距离
						data: impdata
					},
					{
						name: '一般公共预算支出（亿元）',
						type: 'bar',
						barWidth: 25,
						color: '#08e5ff',
						itemStyle: {
							normal: {
								barBorderRadius: 8,   //柱形圆角
							}
						},
						data: expdata
					},
				]
			};
			imexport.setOption(option);
			var startCharts = null;
			// 2、鼠标移动上去的时候的高亮动画
			imexport.on('mouseover', function (param) {
				isSet = false
				clearInterval(startCharts)
				// 取消之前高亮的图形
				imexport.dispatchAction({
					type: 'downplay',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				// 高亮当前图形
				imexport.dispatchAction({
					type: 'highlight',
					seriesIndex: 0,
					dataIndex: param.dataIndex
				})
				// 显示 tooltip
				imexport.dispatchAction({
					type: 'showTip',
					seriesIndex: 0,
					dataIndex: param.dataIndex
				})
			});
			var chartHover = function () {
				var dataLen = option.series[0].data.length
				// 取消之前高亮的图形
				imexport.dispatchAction({
					type: 'downplay',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
				// 高亮当前图形
				imexport.dispatchAction({
					type: 'highlight',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				// 显示 tooltip
				imexport.dispatchAction({
					type: 'showTip',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
			}
			startCharts = setInterval(chartHover, 2000)
			// 4、鼠标移出之后，恢复自动高亮
			imexport.on('mouseout', function (param) {
				if (!isSet) {
					startCharts = setInterval(chartHover, 2000)
					isSet = true
				}
			});
		},

		//地区生产总值
		GDPFun(el, data) {
			var charPie3currentIndex = 0, isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var imexport = echarts.init(document.getElementById(el));
			var _this = this, xdata = [], ydata = [], ydata2 = [];
			for (var i = 0; i < data.length; i++) {
				xdata.push(data[i].year);
				ydata.push(data[i].value);
				ydata2.push(data[i].percent);
			}
			var option = {
				tooltip: {
					trigger: 'axis',
					formatter: function (params) {
						var result = ''
						var dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff"></span>'    // 定义第一个数据前的圆点颜色
						result += dotHtml + params[0].name + "年</br>" + ' 地区生产总值(亿元) ' + params[0].value + "</br>" + '增长率（%）' + params[1].value;
						return result
					}
				},
				legend: { show: false },
				grid: { x: 50, y: 30, x2: 40, y2: 40 },
				xAxis: [
					{
						type: 'category',
						data: xdata,
						axisPointer: {
							type: 'shadow'
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#eee',
							}
						},
						axisLabel: {
							formatter: function (value, index) { return value + '年'; },  // x轴加单位
						},
					}
				],
				yAxis: [
					{
						type: 'value',
						name: '亿元',
						// min: 0,
						// max: 60,  
						axisTick: { "show": true },		//刻度线
						axisLine: {														//轴线
							show: true,
							lineStyle: {
								color: '#eee',
							}
						},  //显示y轴刻度线
						splitLine: { show: false }, //不显示网格线
					},
					{
						name: '%',
						type: 'value',
						// min: 0,
						// max: 10,
						interval: 2,
						axisTick: { "show": true }, //刻度线
						splitLine: { show: false }, //不显示网格
						axisLine: {															//轴线
							show: false,
							lineStyle: {
								color: '#eee',
							}
						},  //显示y轴刻度线
					}
				],
				series: [
					{
						name: '地区生产总值',
						type: 'bar',
						barWidth: 40,
						color: '#1890ff',
						label: {
							normal: {
								show: true,
								position: 'top',
								color: '#fff',
								formatter: '{@score}' + ''//万美元
							}
						},
						data: ydata,
						// itemStyle:{
						// 	normal:{
						// 		barBorderRadius:10,   //柱形圆角
						// 	}
						// },
					},
					{
						name: '增长率',
						type: 'line',
						yAxisIndex: 1,
						color: '#1890ff',
						itemStyle: {
							normal: {
								lineStyle: {
									type: "dotted"
								}
							}
						},
						data: ydata2,
					}
				]
			};
			imexport.setOption(option);
			var startCharts = null;
			// 2、鼠标移动上去的时候的高亮动画
			imexport.on('mouseover', function (param) {
				isSet = false
				clearInterval(startCharts)
				// 取消之前高亮的图形
				imexport.dispatchAction({
					type: 'downplay',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				// 高亮当前图形
				imexport.dispatchAction({
					type: 'highlight',
					seriesIndex: 0,
					dataIndex: param.dataIndex
				})
				// 显示 tooltip
				imexport.dispatchAction({
					type: 'showTip',
					seriesIndex: 0,
					dataIndex: param.dataIndex
				})
			});
			var chartHover = function () {
				var dataLen = option.series[0].data.length
				// 取消之前高亮的图形
				imexport.dispatchAction({
					type: 'downplay',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
				// 高亮当前图形
				imexport.dispatchAction({
					type: 'highlight',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				// 显示 tooltip
				imexport.dispatchAction({
					type: 'showTip',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
			}
			startCharts = setInterval(chartHover, 2000)
			// 4、鼠标移出之后，恢复自动高亮
			imexport.on('mouseout', function (param) {
				if (!isSet) {
					startCharts = setInterval(chartHover, 2000)
					isSet = true
				}
			});
		},


		//产业增加值
		cyaddFun(el, data1, data2, data3) {
			console.log(data1, data2, data3);
			var charPie3currentIndex = 0, isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var Taxchart = echarts.init(document.getElementById(el));
			var xdata = [], industry1 = [], industry2 = [], industry3 = [];
			for (var i = 0; i < data1.length; i++) {
				xdata.push(data1[i].name);
				industry1.push(data1[i].value);
			}
			for (var j = 0; j < data2.length; j++) {
				industry2.push(data2[j].value);
			}
			for (var n = 0; n < data3.length; n++) {
				industry3.push(data3[n].value)
			}
			var option = {
				title: {
					text: '',
				},
				tooltip: {
					show: true,
					trigger: 'axis'
				},
				legend: {
					show: true,
					textStyle: { color: "#eee", fontSize: 12, },
					icon: 'rect',  //图例样式 圆点circle 矩形rect
					itemWidth: 10,
					itemHeight: 9,
					right: '5%',
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				xAxis: [
					{
						type: 'category',
						boundaryGap: false,
						color: "#eee",
						data: xdata,
						axisLine: { show: true, lineStyle: { color: '#eee', } }, 		//轴线
						axisTick: { show: false }, //刻度线
						axisLabel: {
							formatter: function (value, index) { return value + '年'; },  // x轴加单位
						},
					}
				],
				yAxis: [
					{
						type: 'value',
						min: 0,				//最小值
						// max: 400,			//最大值
						// interval: 100,		//步长值
						splitLine: { show: false }, //不显示网格线
						axisLine: { show: false, lineStyle: { color: '#eee', } }, 		//轴线
					}
				],
				series: [
					{
						name: '第一产业（亿元）',
						data: industry1,
						type: 'line',
						smooth: true, //线条平滑

						symbol: 'circle', //拐点样式
						symbolSize: 5,//拐点大小
						color: '#1890ff',
						areaStyle: { color: 'rgba(0,176,255,.5)' },
						// stack: 'Total', //同个类目轴上系列配置相同的stack值后，后一个系列的值会在前一个系列的值上相加
					},
					{
						name: '第二产业（亿元）',
						data: industry2,
						type: 'line',
						smooth: true, //线条平滑
						symbol: 'circle', //拐点样式
						symbolSize: 5,//拐点大小
						areaStyle: { color: 'rgba(254,100,29,.5)' },
						color: '#ffbb1c',
						// stack: 'Total', //同个类目轴上系列配置相同的stack值后，后一个系列的值会在前一个系列的值上相加
					},
					{
						name: '第三产业（亿元）',
						data: industry3,
						type: 'line',
						smooth: true, //线条平滑
						symbol: 'circle', //拐点样式
						symbolSize: 5,//拐点大小
						areaStyle: { color: 'rgba(255, 255, 103, 0.5)' },
						color: '#ffff67',
						// stack: 'Total', //同个类目轴上系列配置相同的stack值后，后一个系列的值会在前一个系列的值上相加
					}
				]
			};
			Taxchart.setOption(option);

		},

		//存贷款情况
		accessFun(el, data1, data2) {
			var charPie3currentIndex = 0, isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var imexport = echarts.init(document.getElementById(el));
			var _this = this, xline = [], expdata = [], impdata = [];
			for (var i = 0; i < data1.length; i++) {
				xline.push(data1[i].name);
				expdata.push(data1[i].value);
			}
			for (var x = 0; x < data2.length; x++) {
				impdata.push(data2[x].value);
			}
			var option = {
				tooltip: {
					trigger: 'axis',
				},
				legend: {
					show: true,
					textStyle: { color: "#eee", fontSize: 12, itemWidth: 10, itemHeight: 10, },
					icon: 'rect',  //图例样式 圆点circle 矩形rect
					itemWidth: 10,
					itemHeight: 10,
					right: '3%',
				},
				grid: { x: 80, y: 10, x2: 40, y2: 40 },
				xAxis: [
					{
						type: 'category',
						data: xline,
						axisPointer: {
							type: 'shadow'
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#eee',
							},
						},
						axisTick: { "show": true },
						axisLabel: {
							formatter: function (value, index) { return value + '年'; },  // x轴加单位
						},
					}
				],
				yAxis: [
					{
						type: 'value',
						name: ' ',
						axisTick: { "show": true },
						axisLine: {
							show: false,
							lineStyle: {
								color: '#eee',
							}
						},
						splitLine: { show: false }, //不显示背景分割线

					},
				],
				series: [
					{
						name: '住户储蓄存款余额（亿元）',
						type: 'bar',
						barWidth: 25,
						color: '#1890ff',
						itemStyle: {
							normal: {
								barBorderRadius: 8,   //柱形圆角
							}
						},
						barGap: '70%',						//柱子之间的距离
						data: impdata
					},
					{
						name: '年末金融机构各项贷款余额（亿元）',
						type: 'bar',
						barWidth: 25,
						color: '#08e5ff',
						itemStyle: {
							normal: {
								barBorderRadius: 8,   //柱形圆角
							}
						},
						data: expdata
					},
				]
			};
			imexport.setOption(option);
			var startCharts = null;
			// 2、鼠标移动上去的时候的高亮动画
			imexport.on('mouseover', function (param) {
				isSet = false
				clearInterval(startCharts)
				// 取消之前高亮的图形
				imexport.dispatchAction({
					type: 'downplay',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				// 高亮当前图形
				imexport.dispatchAction({
					type: 'highlight',
					seriesIndex: 0,
					dataIndex: param.dataIndex
				})
				// 显示 tooltip
				imexport.dispatchAction({
					type: 'showTip',
					seriesIndex: 0,
					dataIndex: param.dataIndex
				})
			});
			var chartHover = function () {
				var dataLen = option.series[0].data.length
				// 取消之前高亮的图形
				imexport.dispatchAction({
					type: 'downplay',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
				// 高亮当前图形
				imexport.dispatchAction({
					type: 'highlight',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				// 显示 tooltip
				imexport.dispatchAction({
					type: 'showTip',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
			}
			startCharts = setInterval(chartHover, 2000)
			// 4、鼠标移出之后，恢复自动高亮
			imexport.on('mouseout', function (param) {
				if (!isSet) {
					startCharts = setInterval(chartHover, 2000)
					isSet = true
				}
			});
		},

	}
}
</script>

<style scoped="scoped"></style>
